import { Link } from "react-router-dom";

interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeader({ eyebrow, title, description, linkTo, linkLabel = "查看全部" }: SectionHeaderProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-6 md:mb-8">
      <div>
        <p className="text-[11px] tracking-[0.3em] text-accent-500 mb-2">{eyebrow}</p>
        <h2 className="font-heading text-xl md:text-2xl text-foreground-950 tracking-wide">{title}</h2>
        {description && <p className="mt-2 text-sm text-foreground-500 max-w-xl leading-relaxed">{description}</p>}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="text-xs text-foreground-500 hover:text-accent-400 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          {linkLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}